<!--
 * @Author: your name
 * @Date: 2021-09-03 09:58:52
 * @LastEditTime: 2021-09-22 14:57:01
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ark-student-wap/src/pages/combinationCourse/components/courseList.vue
-->
<!--  -->
<template>
  <div class="course-list">
    <div class="mandatory">
      <CourseCard v-for="(item, index) in mandatoryCourse" :courseInfo="item" :key="index" />
    </div>
    <div v-for="(item, index) in optionCourse" :key="index">
      <div class="line">
        <p>以下课程{{ showNum(item.groupProductNum) }}选{{ showNum(item.selectProductNum) }}</p>
      </div>
      <div class="option">
        <CourseCard
          v-for="(item, index) in item.packageProductWebRespList"
          :courseInfo="item"
          :key="index"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { getBigNum } from '@/utils/tools';
import { mapState } from 'vuex';
import CourseCard from './courseCard.vue';

export default {
  components: {
    CourseCard,
  },
  data() {
    return {
      mandatoryCourse: [], // 必须课程
      optionCourse: [], // 可选课程
    };
  },
  computed: {
    ...mapState(['courseBaseData']),
  },
  watch: {
    courseBaseData() {
      this.initData();
    },
  },
  methods: {
    showNum(num) {
      return getBigNum(num);
    },
    initData() {
      const { packageProductRespList, packageGroupWebRespList } = this.courseBaseData;
      this.mandatoryCourse = packageProductRespList;
      this.optionCourse = packageGroupWebRespList || [];
    },
  },
  created() {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
.course-list {
  width: 100%;
  padding:36px;
  background: #fff;
}
.line {
  width: 100%;
  height: 94px;
  margin:0 36px 36px 0;
  padding: 0 0 0 40px;
  line-height: 94px;
  background: url('../../../assets/img/public/course-bag.png') no-repeat;
  background-size: 100%;
  p {
    color: #333;
    font-weight: 500;
    font-size: 29px;
    // line-height: 40px;
  }
}
.mandatory{
  >div:last-child{
    margin-bottom: 36px;
  }
}
.option{
  margin-bottom: 36px;
}
</style>
